import useMainStore from "../../../stores/mainStore";
import { toast } from "react-toastify";
import { supabase } from "../../../context/useSupabaseContext";
import { isValidUUID } from "../../isValidUUID";

export default async function removeTableData(
    removeTableData: { deletedData: Deleted; resetDeleted?: boolean }
): Promise<boolean> {
    useMainStore.getState().syncFunctions.addIsUploading("tableRemove");

    try {
        const { data: { user } } = await supabase.auth.getUser();

        if (!user) {
            console.error("No authenticated user found");
            return false;
        }

        const userId = user.id;

        const folderIds = removeTableData.deletedData.folders.filter(
            (id: string) => {
                return isValidUUID(id);
            }
        );
        const noteIds = removeTableData.deletedData.notes.filter(
            (id: string) => {
                return isValidUUID(id);
            }
        );

        if (folderIds.length === 0 && noteIds.length === 0 && !removeTableData.resetDeleted) {
            useMainStore.getState().syncFunctions.removeIsUploading("tableRemove");
            return true;
        }

        if (folderIds.length > 0) {
            const { error: folderError } = await supabase
                .from("folders")
                .delete()
                .in("id", folderIds)
                .eq("user_id", userId);

            if (folderError) {
                throw folderError;
            }
        }

        if (noteIds.length > 0) {
            const { error: noteError } = await supabase
                .from("notes")
                .delete()
                .in("id", noteIds)
                .eq("user_id", userId);

            const bucket = supabase.storage.from("user-data");
            const folderName = userId;
            if (!folderName) {
                throw new Error("Folder name not found");
            }

            const filePaths = noteIds.map(
                (noteID) => `${folderName}/${noteID}`
            );

            const { error: bucketError } = await bucket.remove(filePaths);

            if (noteError) {
                throw noteError;
            }
            if (bucketError) {
                throw bucketError;
            }
        }

        if (removeTableData.resetDeleted) {
            const { error: deletedError } = await supabase
                .from("deleted")
                .delete()
                .eq("user_id", userId);

            if (deletedError) {
                throw deletedError;
            }
        }

        useMainStore.getState().syncFunctions.removeIsUploading("tableRemove");
        useMainStore.getState().syncFunctions.removeChangesMade("tableRemoved");
        useMainStore.getState().syncFunctions.removeChangesMade("noteRemoved");

        return true;
    } catch (error) {
        console.error("Error removing table data:", error);
        toast.error("Failed to remove table data");
        useMainStore.getState().syncFunctions.removeIsUploading("tableRemove");
        return false;
    }
}
